/* PDP photo zoom (snippets/dn-zoom.liquid; 10 Sep 2026: "make the product photos zoom-able").

   The gallery's photos are buttons carrying the large file's URL (data-src) and its pixel size. A tap opens a
   full-screen <dialog> showing the photo the shopper tapped; it zooms by pinch, double-tap, click, wheel or
   the + and - keys, pans by drag or arrow keys, and swipes between photos when not zoomed.

   One transform does all of it: the photo fills the stage with object-fit: contain, and zoom and pan are a
   translate + scale about the stage's centre. A point q on screen (relative to that centre) sits over photo
   point p = (q - t) / s, so zooming to s2 while keeping q still means t2 = q - s2 * p. Panning is clamped to
   the photo's drawn box, not the stage, so a zoomed photo never slides off into its own letterbox.

   Nothing here runs until a tap: no image is fetched and no listener does work while the dialog is shut. A
   browser without <dialog> keeps the plain gallery - the buttons then do nothing, and nothing else changes. */
(function () {
  var dlg = document.querySelector('[data-dn-zoom]');
  if (!dlg || typeof dlg.showModal !== 'function') return;
  var opens = Array.prototype.slice.call(document.querySelectorAll('[data-dn-zoom-open]'));
  if (!opens.length) return;

  var photos = opens.map(function (b) {
    return { src: b.getAttribute('data-src'), w: Number(b.getAttribute('data-w')) || 0, h: Number(b.getAttribute('data-h')) || 0, thumb: b.querySelector('img') };
  });
  var stage = dlg.querySelector('[data-dn-zoom-stage]');
  var img = dlg.querySelector('[data-dn-zoom-img]');
  var count = dlg.querySelector('[data-dn-zoom-count]');
  var toggle = dlg.querySelector('[data-dn-zoom-toggle]');
  var plus = dlg.querySelector('[data-dn-zoom-plus]');
  var prev = dlg.querySelector('[data-dn-zoom-prev]');
  var next = dlg.querySelector('[data-dn-zoom-next]');
  var STEP = 2.5, MAX = 4;
  var i = 0, s = 1, tx = 0, ty = 0, raf = 0;
  var pointers = {}, npointers = 0, pinch = null, drag = null, moved = false, lastTap = 0;

  if (photos.length < 2) { prev.hidden = true; next.hidden = true; }

  function paint() {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = 0; img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + s + ')'; });
  }
  /* The photo's drawn box at scale 1: object-fit: contain inside the stage. */
  function box() {
    var r = stage.getBoundingClientRect(), p = photos[i];
    var nw = img.naturalWidth || p.w || r.width, nh = img.naturalHeight || p.h || r.height;
    var fit = Math.min(r.width / nw, r.height / nh);
    return { w: nw * fit, h: nh * fit, sw: r.width, sh: r.height };
  }
  function clamp() {
    var b = box(), mx = Math.max(0, (b.w * s - b.sw) / 2), my = Math.max(0, (b.h * s - b.sh) / 2);
    tx = Math.min(mx, Math.max(-mx, tx)); ty = Math.min(my, Math.max(-my, ty));
  }
  function mark() {
    var z = s > 1.01;
    stage.classList.toggle('is-zoomed', z);
    toggle.setAttribute('aria-label', z ? 'Zoom out' : 'Zoom in');
    if (plus) plus.style.display = z ? 'none' : '';
  }
  function zoomTo(ns, qx, qy) {
    ns = Math.min(MAX, Math.max(1, ns));
    qx = qx || 0; qy = qy || 0;
    tx = qx - ns * (qx - tx) / s; ty = qy - ns * (qy - ty) / s; s = ns;
    if (s < 1.01) { s = 1; tx = 0; ty = 0; }
    clamp(); paint(); mark();
  }
  function rel(x, y) { var r = stage.getBoundingClientRect(); return { x: x - r.left - r.width / 2, y: y - r.top - r.height / 2 }; }

  function show(n) {
    i = (n + photos.length) % photos.length;
    var p = photos[i], want = i;
    s = 1; tx = 0; ty = 0; img.style.transform = ''; mark();
    /* The gallery's own file first, so the viewer is never blank; the large one replaces it once it has loaded. */
    img.src = (p.thumb && (p.thumb.currentSrc || p.thumb.src)) || p.src;
    img.alt = p.thumb ? p.thumb.alt : '';
    if (p.src && img.src !== p.src) {
      var big = new Image();
      big.onload = function () { if (i === want) img.src = p.src; };
      big.src = p.src;
    }
    count.textContent = photos.length > 1 ? 'Photo ' + (i + 1) + ' of ' + photos.length : '';
  }

  function points() { var a = []; for (var k in pointers) a.push(pointers[k]); return a; }
  function spread(a) { return Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y) || 1; }

  stage.addEventListener('pointerdown', function (e) {
    if (e.button > 0) return;
    try { stage.setPointerCapture(e.pointerId); } catch (err) {}
    pointers[e.pointerId] = { x: e.clientX, y: e.clientY }; npointers++;
    if (npointers === 2) {
      var a = points(), m = rel((a[0].x + a[1].x) / 2, (a[0].y + a[1].y) / 2);
      pinch = { d: spread(a), s: s, tx: tx, ty: ty, m: m }; drag = null; moved = true;
    } else if (npointers === 1) {
      drag = { x: e.clientX, y: e.clientY, tx: tx, ty: ty }; moved = false;
    }
  });
  stage.addEventListener('pointermove', function (e) {
    if (!pointers[e.pointerId]) return;
    pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
    if (pinch && npointers === 2) {
      var a = points(), m = rel((a[0].x + a[1].x) / 2, (a[0].y + a[1].y) / 2);
      s = pinch.s; tx = pinch.tx; ty = pinch.ty;
      zoomTo(pinch.s * spread(a) / pinch.d, pinch.m.x, pinch.m.y);
      tx += m.x - pinch.m.x; ty += m.y - pinch.m.y; clamp(); paint();
    } else if (drag) {
      var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
      if (Math.abs(dx) + Math.abs(dy) > 6) moved = true;
      if (s > 1 && moved) { tx = drag.tx + dx; ty = drag.ty + dy; clamp(); paint(); stage.classList.add('is-dragging'); }
    }
  });
  function lift(e) {
    if (!pointers[e.pointerId]) return;
    delete pointers[e.pointerId]; npointers--;
    stage.classList.remove('is-dragging');
    if (pinch) {
      if (npointers < 2) {
        pinch = null;
        var rest = points()[0];
        drag = rest ? { x: rest.x, y: rest.y, tx: tx, ty: ty } : null;
      }
      return;
    }
    if (!drag || npointers > 0) return;
    var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
    if (e.type === 'pointerup' && s === 1 && e.pointerType !== 'mouse' && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
      show(i + (dx < 0 ? 1 : -1));
    } else if (e.type === 'pointerup' && !moved) {
      var q = rel(e.clientX, e.clientY), now = Date.now();
      if (e.pointerType === 'mouse' || now - lastTap < 300) { zoomTo(s > 1 ? 1 : STEP, q.x, q.y); lastTap = 0; }
      else lastTap = now;
    }
    drag = null;
  }
  stage.addEventListener('pointerup', lift);
  stage.addEventListener('pointercancel', lift);
  stage.addEventListener('wheel', function (e) {
    e.preventDefault();
    var q = rel(e.clientX, e.clientY);
    zoomTo(s * Math.exp(-e.deltaY * 0.0015), q.x, q.y);
  }, { passive: false });

  toggle.addEventListener('click', function () { zoomTo(s > 1 ? 1 : STEP); });
  prev.addEventListener('click', function () { show(i - 1); });
  next.addEventListener('click', function () { show(i + 1); });
  dlg.querySelector('[data-dn-zoom-close]').addEventListener('click', function () { dlg.close(); });

  dlg.addEventListener('keydown', function (e) {
    var k = e.key, zoomed = s > 1;
    if (k === '+' || k === '=') { zoomTo(s * 1.5); }
    else if (k === '-' || k === '_') { zoomTo(s / 1.5); }
    else if (k === '0') { zoomTo(1); }
    else if (k === 'ArrowLeft' || k === 'ArrowRight') {
      if (zoomed) { tx += k === 'ArrowLeft' ? 60 : -60; clamp(); paint(); } else show(i + (k === 'ArrowLeft' ? -1 : 1));
    } else if (zoomed && (k === 'ArrowUp' || k === 'ArrowDown')) { ty += k === 'ArrowUp' ? 60 : -60; clamp(); paint(); }
    else return;
    e.preventDefault();
  });
  window.addEventListener('resize', function () { if (dlg.open) { clamp(); paint(); } });

  opens.forEach(function (b, k) {
    b.addEventListener('click', function () {
      show(k);
      document.documentElement.classList.add('dn-zoom-lock');
      dlg.showModal();
    });
  });
  /* On close, leave the gallery on the photo the shopper ended on, and put focus on it. */
  dlg.addEventListener('close', function () {
    document.documentElement.classList.remove('dn-zoom-lock');
    pointers = {}; npointers = 0; pinch = null; drag = null;
    var b = opens[i];
    setTimeout(function () {
      var li = b.closest('li'), track = li && li.parentElement;
      if (track) track.scrollTo({ left: li.offsetLeft - track.offsetLeft, behavior: 'auto' });
      b.focus({ preventScroll: true });
    }, 0);
  });
})();
